/* eslint-disable no-unused-expressions */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import {
  Box,
  Avatar,
  Stack,
  Typography,
  Card,
  Divider,
  ButtonBase,
} from '@mui/material';
import { styled } from '@mui/system';
import { tokens } from '../../../tokens';

// const CVVIButton = styled(ButtonBase)(({ theme }) => ({
//   position: 'relative',
//   maxHeight: 600,
//   [theme.breakpoints.down('sm')]: {
//     width: '100% !important', // Overrides inline-style
//     maxHeight: 250,
//   },
//   '&:hover, &.Mui-focusVisible': {
//     zIndex: 99,
//     '& .MuiImageBackdrop-root': {
//       opacity: 0.15,
//       backgroundColor: tokens.token_apple_grey,
//     },
//     '& .MuiImageMarked-root': {
//       opacity: 0,
//     },
//     '& .MuiTypography-root': {
//       border: '4px solid currentColor',
//     },
//   },
// }));

// const CVVIBackdrop = styled('span')(({ theme }) => ({
//   position: 'absolute',
//   left: 0,
//   right: 0,
//   top: 0,
//   bottom: 0,
//   backgroundColor: tokens.token_surface,
//   opacity: 0,
//   transition: theme.transitions.create('opacity'),
// }));

const LogoMarked = styled('span')(({ theme }) => ({
  height: '22px',
  width: '92px',
  // backgroundColor: tokens.token_black,
  position: 'absolute',
  top: 5,
  right: 'calc(70% - 9px)',
  '&:hover, &.Mui-focusVisible': {
    zIndex: 99,
    '& .MuiImageBackdrop-root': {
      opacity: 0.15,
    },
  },
  transition: theme.transitions.create('opacity'),
}));

const NameTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,sans-serif',
  fontSize: '.85rem',
  fontWeight: 400,
  color: tokens.token_text_grey_on_white,
  lineHeight: '1.00rem',
  letterSpacing: '.025em',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'left',
}));

const DataTypo = styled(Typography)(() => ({
  fontFamily: 'Google Sans, Roboto, Arial, sans-serif',
  fontSize: '0.85rem',
  fontWeight: 500,
  lineHeight: '1.00rem',
  letterSpacing: '.025em',
  textAlign: 'left',
  color: tokens.token_typography_regular_emphasized,
}));

const DefTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,sans-serif',
  fontSize: '.75rem',
  fontWeight: 400,
  color: tokens.token_text_grey_on_white,
  lineHeight: '1.00rem',
  letterSpacing: '.025em',
  // whiteSpace: 'nowrap',
  // overflow: 'hidden',
  // textOverflow: 'ellipsis',
  textAlign: 'left',
}));
const IndexTypo = styled(Typography)(() => ({
  fontFamily: 'Google Sans, Roboto, Arial, sans-serif',
  fontSize: '0.85rem',
  fontWeight: 500,
  lineHeight: '1.00rem',
  letterSpacing: '.025em',
  textAlign: 'left',
  color: tokens.token_typography_regular_emphasized,
}));
const CVVICard = styled(Card)(() => ({
  border: '1px solid',
  borderColor: 'transparent',
  borderRadius: '12px',
  width: '375px',
  height: '225px',
  backgroundColor: tokens.token_surface,
  justifyContent: 'center',
  alignItems: 'center',
  // marginRight: '5px',
  // '&:hover': {
  //   boxShadow: '0 0 5px #9aa0a6',
  // },
}));

const ReactSpeedometer = dynamic(() => import('react-d3-speedometer'), {
  ssr: false,
});
export default function AboutCryptoCVVIGauge() {
  return (
    <CVVICard variant="outlined" sx={{}}>
      <ReactSpeedometer
        fluidWidth="true"
        // width={380}
        // height={200}
        minValue={0}
        maxValue={100}
        value={50}
        valueFormat="d"
        // customSegmentStops={[0, 20, 40, 60, 80, 100]}
        needleColor="#0A2B3B"
        needleHeightRatio={0.8}
        //   segmentValueFormatter={segmentValueFormatter}
        segmentColors={['#fff2e8', '#ffdabf', '#ffb987', '#ff9b54', '#FF7E24']}
        color="#5F6368"
        valueTextFontSize="0.85rem"
        currentValueText="Crypto Vice and Virtue Index™: ${value}"
        // paddingHorizontal={34}
        // paddingVertical={34}
        customSegmentLabels={[
          {
            text: 'Virtue',
            position: 'INSIDE',
            color: tokens.palette_primary,
            fontSize: '10px',
          },
          {
            text: 'Benevolence',
            position: 'INSIDE',
            color: tokens.palette_primary,
            fontSize: '10px',
          },
          {
            text: 'Balance',
            position: 'INSIDE',
            color: tokens.palette_primary,
            fontSize: '10px',
          },
          {
            text: 'Malice',
            position: 'INSIDE',
            color: tokens.palette_primary,
            fontSize: '10px',
          },
          {
            text: 'Vice',
            position: 'INSIDE',
            color: tokens.palette_primary,
            fontSize: '10px',
          },
        ]}
      />
      {/* <LogoMarked className="MuiImageMarked-root">
            <Image
              width={92}
              height={21}
              src="/blockquiry92x21.png"
              alt="logo"
            />
          </LogoMarked> */}
      {/* </CVVIButton> */}
    </CVVICard>
  );
}
